// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v1.181.2
//   protoc               v3.21.6
// source: candle-data-depot-common.proto

/* eslint-disable */
import * as _m0 from "protobufjs/minimal";
import { Exchange, exchangeFromJSON, exchangeToJSON, OptionGreeks } from "./common";
import Long from "long";

export const protobufPackage = "com.tick2trade.api.candledatadepot";

export interface Security {
  exchange: Exchange;
  code: string;
}

export interface Candle {
  startTimestamp: number;
  open: number;
  high: number;
  low: number;
  close: number;
  volume: number;
  vwap: number;
  impliedVolatility: number;
  optionGreeks: OptionGreeks | undefined;
  referencedSecurityCode: string;
  topBid: number;
  topAsk: number;
  openInterest: number;
  preOpenVolume: number;
  callOpenInterest: number;
  putOpenInterest: number;
  maxPain: number;
  deliveryPercentage: number;
}

function createBaseSecurity(): Security {
  return { exchange: 0, code: "" };
}

export const Security = {
  encode(message: Security, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.exchange !== 0) {
      writer.uint32(8).int32(message.exchange);
    }
    if (message.code !== "") {
      writer.uint32(18).string(message.code);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): Security {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSecurity();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.exchange = reader.int32() as any;
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.code = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Security {
    return {
      exchange: isSet(object.exchange) ? exchangeFromJSON(object.exchange) : 0,
      code: isSet(object.code) ? globalThis.String(object.code) : "",
    };
  },

  toJSON(message: Security): unknown {
    const obj: any = {};
    if (message.exchange !== 0) {
      obj.exchange = exchangeToJSON(message.exchange);
    }
    if (message.code !== "") {
      obj.code = message.code;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Security>, I>>(base?: I): Security {
    return Security.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Security>, I>>(object: I): Security {
    const message = createBaseSecurity();
    message.exchange = object.exchange ?? 0;
    message.code = object.code ?? "";
    return message;
  },
};

function createBaseCandle(): Candle {
  return {
    startTimestamp: 0,
    open: 0,
    high: 0,
    low: 0,
    close: 0,
    volume: 0,
    vwap: 0,
    impliedVolatility: 0,
    optionGreeks: undefined,
    referencedSecurityCode: "",
    topBid: 0,
    topAsk: 0,
    openInterest: 0,
    preOpenVolume: 0,
    callOpenInterest: 0,
    putOpenInterest: 0,
    maxPain: 0,
    deliveryPercentage: 0,
  };
}

export const Candle = {
  encode(message: Candle, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.startTimestamp !== 0) {
      writer.uint32(24).int64(message.startTimestamp);
    }
    if (message.open !== 0) {
      writer.uint32(48).int32(message.open);
    }
    if (message.high !== 0) {
      writer.uint32(64).int32(message.high);
    }
    if (message.low !== 0) {
      writer.uint32(80).int32(message.low);
    }
    if (message.close !== 0) {
      writer.uint32(96).int32(message.close);
    }
    if (message.volume !== 0) {
      writer.uint32(112).int64(message.volume);
    }
    if (message.vwap !== 0) {
      writer.uint32(133).float(message.vwap);
    }
    if (message.impliedVolatility !== 0) {
      writer.uint32(165).float(message.impliedVolatility);
    }
    if (message.optionGreeks !== undefined) {
      OptionGreeks.encode(message.optionGreeks, writer.uint32(186).fork()).ldelim();
    }
    if (message.referencedSecurityCode !== "") {
      writer.uint32(194).string(message.referencedSecurityCode);
    }
    if (message.topBid !== 0) {
      writer.uint32(208).int32(message.topBid);
    }
    if (message.topAsk !== 0) {
      writer.uint32(224).int32(message.topAsk);
    }
    if (message.openInterest !== 0) {
      writer.uint32(232).int32(message.openInterest);
    }
    if (message.preOpenVolume !== 0) {
      writer.uint32(240).int64(message.preOpenVolume);
    }
    if (message.callOpenInterest !== 0) {
      writer.uint32(280).int32(message.callOpenInterest);
    }
    if (message.putOpenInterest !== 0) {
      writer.uint32(320).int32(message.putOpenInterest);
    }
    if (message.maxPain !== 0) {
      writer.uint32(360).int32(message.maxPain);
    }
    if (message.deliveryPercentage !== 0) {
      writer.uint32(405).float(message.deliveryPercentage);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): Candle {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCandle();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 3:
          if (tag !== 24) {
            break;
          }

          message.startTimestamp = longToNumber(reader.int64() as Long);
          continue;
        case 6:
          if (tag !== 48) {
            break;
          }

          message.open = reader.int32();
          continue;
        case 8:
          if (tag !== 64) {
            break;
          }

          message.high = reader.int32();
          continue;
        case 10:
          if (tag !== 80) {
            break;
          }

          message.low = reader.int32();
          continue;
        case 12:
          if (tag !== 96) {
            break;
          }

          message.close = reader.int32();
          continue;
        case 14:
          if (tag !== 112) {
            break;
          }

          message.volume = longToNumber(reader.int64() as Long);
          continue;
        case 16:
          if (tag !== 133) {
            break;
          }

          message.vwap = reader.float();
          continue;
        case 20:
          if (tag !== 165) {
            break;
          }

          message.impliedVolatility = reader.float();
          continue;
        case 23:
          if (tag !== 186) {
            break;
          }

          message.optionGreeks = OptionGreeks.decode(reader, reader.uint32());
          continue;
        case 24:
          if (tag !== 194) {
            break;
          }

          message.referencedSecurityCode = reader.string();
          continue;
        case 26:
          if (tag !== 208) {
            break;
          }

          message.topBid = reader.int32();
          continue;
        case 28:
          if (tag !== 224) {
            break;
          }

          message.topAsk = reader.int32();
          continue;
        case 29:
          if (tag !== 232) {
            break;
          }

          message.openInterest = reader.int32();
          continue;
        case 30:
          if (tag !== 240) {
            break;
          }

          message.preOpenVolume = longToNumber(reader.int64() as Long);
          continue;
        case 35:
          if (tag !== 280) {
            break;
          }

          message.callOpenInterest = reader.int32();
          continue;
        case 40:
          if (tag !== 320) {
            break;
          }

          message.putOpenInterest = reader.int32();
          continue;
        case 45:
          if (tag !== 360) {
            break;
          }

          message.maxPain = reader.int32();
          continue;
        case 50:
          if (tag !== 405) {
            break;
          }

          message.deliveryPercentage = reader.float();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Candle {
    return {
      startTimestamp: isSet(object.startTimestamp) ? globalThis.Number(object.startTimestamp) : 0,
      open: isSet(object.open) ? globalThis.Number(object.open) : 0,
      high: isSet(object.high) ? globalThis.Number(object.high) : 0,
      low: isSet(object.low) ? globalThis.Number(object.low) : 0,
      close: isSet(object.close) ? globalThis.Number(object.close) : 0,
      volume: isSet(object.volume) ? globalThis.Number(object.volume) : 0,
      vwap: isSet(object.vwap) ? globalThis.Number(object.vwap) : 0,
      impliedVolatility: isSet(object.impliedVolatility) ? globalThis.Number(object.impliedVolatility) : 0,
      optionGreeks: isSet(object.optionGreeks) ? OptionGreeks.fromJSON(object.optionGreeks) : undefined,
      referencedSecurityCode: isSet(object.referencedSecurityCode)
        ? globalThis.String(object.referencedSecurityCode)
        : "",
      topBid: isSet(object.topBid) ? globalThis.Number(object.topBid) : 0,
      topAsk: isSet(object.topAsk) ? globalThis.Number(object.topAsk) : 0,
      openInterest: isSet(object.openInterest) ? globalThis.Number(object.openInterest) : 0,
      preOpenVolume: isSet(object.preOpenVolume) ? globalThis.Number(object.preOpenVolume) : 0,
      callOpenInterest: isSet(object.callOpenInterest) ? globalThis.Number(object.callOpenInterest) : 0,
      putOpenInterest: isSet(object.putOpenInterest) ? globalThis.Number(object.putOpenInterest) : 0,
      maxPain: isSet(object.maxPain) ? globalThis.Number(object.maxPain) : 0,
      deliveryPercentage: isSet(object.deliveryPercentage) ? globalThis.Number(object.deliveryPercentage) : 0,
    };
  },

  toJSON(message: Candle): unknown {
    const obj: any = {};
    if (message.startTimestamp !== 0) {
      obj.startTimestamp = Math.round(message.startTimestamp);
    }
    if (message.open !== 0) {
      obj.open = Math.round(message.open);
    }
    if (message.high !== 0) {
      obj.high = Math.round(message.high);
    }
    if (message.low !== 0) {
      obj.low = Math.round(message.low);
    }
    if (message.close !== 0) {
      obj.close = Math.round(message.close);
    }
    if (message.volume !== 0) {
      obj.volume = Math.round(message.volume);
    }
    if (message.vwap !== 0) {
      obj.vwap = message.vwap;
    }
    if (message.impliedVolatility !== 0) {
      obj.impliedVolatility = message.impliedVolatility;
    }
    if (message.optionGreeks !== undefined) {
      obj.optionGreeks = OptionGreeks.toJSON(message.optionGreeks);
    }
    if (message.referencedSecurityCode !== "") {
      obj.referencedSecurityCode = message.referencedSecurityCode;
    }
    if (message.topBid !== 0) {
      obj.topBid = Math.round(message.topBid);
    }
    if (message.topAsk !== 0) {
      obj.topAsk = Math.round(message.topAsk);
    }
    if (message.openInterest !== 0) {
      obj.openInterest = Math.round(message.openInterest);
    }
    if (message.preOpenVolume !== 0) {
      obj.preOpenVolume = Math.round(message.preOpenVolume);
    }
    if (message.callOpenInterest !== 0) {
      obj.callOpenInterest = Math.round(message.callOpenInterest);
    }
    if (message.putOpenInterest !== 0) {
      obj.putOpenInterest = Math.round(message.putOpenInterest);
    }
    if (message.maxPain !== 0) {
      obj.maxPain = Math.round(message.maxPain);
    }
    if (message.deliveryPercentage !== 0) {
      obj.deliveryPercentage = message.deliveryPercentage;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Candle>, I>>(base?: I): Candle {
    return Candle.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Candle>, I>>(object: I): Candle {
    const message = createBaseCandle();
    message.startTimestamp = object.startTimestamp ?? 0;
    message.open = object.open ?? 0;
    message.high = object.high ?? 0;
    message.low = object.low ?? 0;
    message.close = object.close ?? 0;
    message.volume = object.volume ?? 0;
    message.vwap = object.vwap ?? 0;
    message.impliedVolatility = object.impliedVolatility ?? 0;
    message.optionGreeks = (object.optionGreeks !== undefined && object.optionGreeks !== null)
      ? OptionGreeks.fromPartial(object.optionGreeks)
      : undefined;
    message.referencedSecurityCode = object.referencedSecurityCode ?? "";
    message.topBid = object.topBid ?? 0;
    message.topAsk = object.topAsk ?? 0;
    message.openInterest = object.openInterest ?? 0;
    message.preOpenVolume = object.preOpenVolume ?? 0;
    message.callOpenInterest = object.callOpenInterest ?? 0;
    message.putOpenInterest = object.putOpenInterest ?? 0;
    message.maxPain = object.maxPain ?? 0;
    message.deliveryPercentage = object.deliveryPercentage ?? 0;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function longToNumber(long: Long): number {
  if (long.gt(globalThis.Number.MAX_SAFE_INTEGER)) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  if (long.lt(globalThis.Number.MIN_SAFE_INTEGER)) {
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  }
  return long.toNumber();
}

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any;
  _m0.configure();
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
